import type { NavigationGuard } from 'vue-router'

import { Navigation404Error } from '~/router/errors'

import { useUsersStore } from '~/entities/user/user/stores/users'

import { useTranslations } from '~/features-generic/translations/composables/translations'

async function checkNetworkActivityAccess(selectedUserHashKey?: string) {
  const userStore = useUsersStore()
  const { $i18n } = useTranslations('error')
  await userStore.fetchCurrentUser()

  if (userStore.currentUser?.hash_key !== selectedUserHashKey)
    return true

  throw new Navigation404Error($i18n('ThisContentDoesntExist'))
}

export const navigationGuardNetwork: NavigationGuard = (to, from, next) => {
  return Promise.resolve()
    .then(() => {
      // check only if network-user-thread_id
      if (to.name.includes('network-user-thread_id'))
        return checkNetworkActivityAccess(to.params.thread_id)
      return true
    })
    .then(() => next())
    .catch(error => next(error))
}
